// polyfill.js
'use strict';
import URLSearchParams from '@ungap/url-search-params';
import smoothscroll from 'smoothscroll-polyfill';
import '../resource/intersectionObserver.js';
import AudioRecorder from 'audio-recorder-polyfill';
import '../resource/canvasToBlob.js';
import ResizeObserver from 'resize-observer-polyfill';

if (!window.URLSearchParams) {
  window.URLSearchParams = URLSearchParams;
}

if (window) {
  smoothscroll.polyfill();
}

if (window) {
  window.MediaRecorder = AudioRecorder;
}

if (!window.requestIdleCallback) {
  // ref: https://github.com/pladaria/requestidlecallback-polyfill/blob/master/index.js
  window.requestIdleCallback = (callback, options = {}) => {
    const startTime = Date.now();
    const timeout = options.timeout || 0;

    return setTimeout(() => {
      const now = Date.now();
      callback({
        timeRemaining() {
          return Math.max(0, 50 - (now - startTime));
        },
        didTimeout: timeout > 0 && now - startTime >= timeout,
      });
    }, 1);
  };
}

if (!window.cancelIdleCallback) {
  window.cancelIdleCallback = function (id) {
    window.clearTimeout(id);
  };
}

if (!window.ResizeObserver) {
  window.ResizeObserver = ResizeObserver;
}

if (!JSON.safeStringify) {
  // safely handles circular references
  // ref: https://stackoverflow.com/a/11616993
  JSON.safeStringify = (object, indent = 2) => {
    let cache = [];
    const result = JSON.stringify(
      object,
      (key, value) => {
        let result = value;
        if (typeof value === 'object' && value !== null) {
          if (cache.includes(value)) {
            result = '[Duplicate]';
          } else {
            cache.push(value); // Store value in our collection
            if (Object.keys(value).length > 128) {
              result = `[Object keys: ${Object.keys(value).length}]`;
            }
          }
        }
        return result;
      },
      indent
    );
    cache = null;
    return result;
  };
}

if (typeof Promise.withResolvers === 'undefined') {
  Promise.withResolvers = function () {
    let resolve, reject;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}
